import { render, staticRenderFns } from "./Replenishmentdetails.vue?vue&type=template&id=22e51050&scoped=true&"
import script from "./Replenishmentdetails.vue?vue&type=script&lang=js&"
export * from "./Replenishmentdetails.vue?vue&type=script&lang=js&"
import style0 from "./Replenishmentdetails.vue?vue&type=style&index=0&id=22e51050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e51050",
  null
  
)

export default component.exports